<span class="{{decoratorClasses}}">
  <span [ngStyle]="{'background-color': _containerClasses.includes('action') ? '#2ECC71' : 'none'}" class="{{_containerClasses}}" title="{{alternativeText}}">
    <svg class="slds-icon {{_svgClasses}}" aria-hidden="true">
      <use attr.xlink:href="{{iconPath}}"></use>
    </svg>
    <span class="slds-assistive-text">{{alternativeText}}</span>
  </span>
</span>
